import { LoyaltyCampaign } from '@/types'
import { createContext } from 'react'

export const LoyaltyCampaignContext = createContext<LoyaltyCampaign | undefined>(undefined)
